// extracted by mini-css-extract-plugin
export default {"pcc_content":"PatientCareCenter_pcc_content__l+32T","loading_div":"PatientCareCenter_loading_div__JtWsO"};